var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "34px",
            "line-height": "30px",
            "padding-left": "10px",
            "font-size": "14px",
            "background-color": "#EFEFEF"
          }
        },
        [
          _vm._v("\n        查询字段\n        "),
          !_vm.viewMode
            ? _c(
                "span",
                { staticClass: "ml10" },
                [
                  _vm.userMode == 0
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: { type: "danger", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.clearQueryFields()
                            }
                          }
                        },
                        [_vm._v("清除所有字段")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode == 0
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20 mr20",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.addQueryField()
                            }
                          }
                        },
                        [_vm._v("+ 追加字段")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode == 0
                    ? _c("el-divider", { attrs: { direction: "vertical" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode < 2
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: {
                            type: "primary",
                            size: "mini",
                            title: "把固定列按未来结果排在最前面"
                          },
                          on: {
                            click: function($event) {
                              _vm.bttopBasicFields()
                            }
                          }
                        },
                        [_vm._v("基本项置于前")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userMode == 2 && !_vm.viewMode
            ? _c(
                "span",
                { staticClass: "fr mr5" },
                [
                  _c(
                    "el-link",
                    {
                      staticClass: "ml20",
                      staticStyle: {
                        "padding-bottom": "2px",
                        "font-size": "13px"
                      },
                      attrs: {
                        type: "primary",
                        size: "mini",
                        title: "把固定列按未来结果排在最前面"
                      },
                      on: {
                        click: function($event) {
                          _vm.bttopBasicFields()
                        }
                      }
                    },
                    [_vm._v("基本项置于前")]
                  ),
                  _vm._v(" "),
                  _vm.showExtBtns
                    ? _c(
                        "span",
                        { staticClass: "fr ml30 mr5" },
                        [
                          _vm.custSavable && _vm.onSaveCustConf != null
                            ? _c(
                                "label",
                                {
                                  staticStyle: { "font-size": "12px" },
                                  attrs: {
                                    title: "保存调整的同时带着当前查询条件值"
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.widthCurValues,
                                        expression: "widthCurValues"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.widthCurValues)
                                        ? _vm._i(_vm.widthCurValues, null) > -1
                                        : _vm.widthCurValues
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.widthCurValues,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.widthCurValues = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.widthCurValues = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.widthCurValues = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v("带值")
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.custSavable && _vm.onSaveCustConf != null
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-document-checked",
                                    title: "保存个性调整"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.handleSaveCustConf()
                                    }
                                  }
                                },
                                [_vm._v("保存调整")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.custSavable && _vm.onSaveCustConf != null
                            ? _c("el-divider", {
                                attrs: { direction: "vertical" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-top": "1px" },
                              attrs: {
                                size: "mini",
                                icon: "el-icon-check",
                                title: "应用调整"
                              },
                              on: {
                                click: function($event) {
                                  _vm.handleConfirm()
                                }
                              }
                            },
                            [_vm._v("应用")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "ml20 mr5",
                              staticStyle: {
                                width: "30px",
                                height: "30px",
                                "text-align": "center",
                                "vertical-align": "middle"
                              },
                              attrs: { title: "取消/关闭" },
                              on: {
                                click: function($event) {
                                  _vm.handleClose()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-close",
                                staticStyle: { "font-size": "18px" }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userMode == 0 && !_vm.viewMode
            ? _c("span", { staticClass: "fr mr5" }, [
                _c(
                  "span",
                  [
                    _c("el-input", {
                      staticClass: "mr10",
                      staticStyle: { width: "100px" },
                      attrs: {
                        size: "mini",
                        placeholder: "输入 过滤文本",
                        clearable: ""
                      },
                      on: { change: _vm.filterList },
                      model: {
                        value: _vm.instantKeyword,
                        callback: function($$v) {
                          _vm.instantKeyword = $$v
                        },
                        expression: "instantKeyword"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _vm._v(" "),
                    _vm.forHisQry
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-link",
                              {
                                staticClass: "ml10 mr10",
                                staticStyle: {
                                  "padding-bottom": "2px",
                                  "font-size": "13px"
                                },
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  icon: "el-icon-notebook-2"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.appendFromCols()
                                  }
                                }
                              },
                              [_vm._v("从表列选择")]
                            ),
                            _vm._v(" "),
                            _c("el-divider", {
                              attrs: { direction: "vertical" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.uiUnion
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-link",
                          {
                            staticClass: "ml10 mr10",
                            staticStyle: {
                              "padding-bottom": "2px",
                              "font-size": "13px"
                            },
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-document",
                              title: "meta queryFields"
                            },
                            on: {
                              click: function($event) {
                                _vm.inputJsonConf()
                              }
                            }
                          },
                          [_vm._v("输入json配置")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        {
          ref: "fieldExtPopover",
          attrs: { disabled: _vm.userMode != 0 },
          on: {
            show: function($event) {
              _vm.syncFieldExtEditorVisible(true)
            },
            hide: function($event) {
              _vm.syncFieldExtEditorVisible(false)
            }
          },
          model: {
            value: _vm.fieldExtEditorVisible,
            callback: function($$v) {
              _vm.fieldExtEditorVisible = $$v
            },
            expression: "fieldExtEditorVisible"
          }
        },
        [
          _c("swb-prop-editor", {
            attrs: {
              title: _vm.fieldExtEditor.title,
              showBtnBar: _vm.fieldExtEditor.showBtnBar,
              width: _vm.fieldExtEditor.width,
              widthForLabel: _vm.fieldExtEditor.widthForLabel,
              propList: _vm.fieldExtEditor.propList,
              extra: _vm.fieldExtEditor.extra,
              viewMode: _vm.fieldExtEditor.viewMode,
              readOnly: _vm.fieldExtEditor.readOnly,
              onConfirm: _vm.onFieldExtEditorConfirm,
              onCancel: _vm.onFieldExtEditorCancel
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        {
          ref: "dynaTagPopover",
          attrs: { disabled: _vm.userMode != 0 },
          on: {
            show: function($event) {
              _vm.syncDynaTagEditorVisible(true)
            },
            hide: function($event) {
              _vm.syncDynaTagEditorVisible(false)
            }
          },
          model: {
            value: _vm.dynaTagEditorVisible,
            callback: function($$v) {
              _vm.dynaTagEditorVisible = $$v
            },
            expression: "dynaTagEditorVisible"
          }
        },
        [
          _c("swb-prop-editor", {
            attrs: {
              title: _vm.dynaTagEditor.title,
              showBtnBar: _vm.dynaTagEditor.showBtnBar,
              width: _vm.dynaTagEditor.width,
              widthForLabel: _vm.dynaTagEditor.widthForLabel,
              propList: _vm.dynaTagEditor.propList,
              extra: _vm.dynaTagEditor.extra,
              viewMode: _vm.dynaTagEditor.viewMode,
              readOnly: _vm.dynaTagEditor.readOnly,
              onConfirm: _vm.onDynaTagEditorConfirm,
              onCancel: _vm.onDynaTagEditorCancel
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "gridForm",
          staticClass: "query-conf-form",
          staticStyle: { transition: "height 0.2s ease-in-out" },
          attrs: { name: "gridTableWrapper", model: _vm.gridForm }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "row-draggable",
                  rawName: "v-row-draggable",
                  value: _vm.makeDragCtxData(),
                  expression: "makeDragCtxData()"
                }
              ],
              ref: "gridTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.gridForm.fieldConfRows,
                "row-class-name": _vm.getQueryRowClassName,
                "row-key": _vm.rowItemKey,
                height: _vm.gridHeight,
                stripe: "",
                "highlight-current-row": "",
                size: "mini"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "58",
                  align: "center",
                  type: "index",
                  fixed: ""
                }
              }),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "代码", width: "120", fixed: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "fieldConfRows[" + scope.$index + "].code"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "field-code",
                                  attrs: { maxlength: "30", size: "mini" },
                                  model: {
                                    value: scope.row.code,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "code", $$v)
                                    },
                                    expression: "scope.row.code"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "标签", width: "100", fixed: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "text" },
                          [
                            _vm.userMode == 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      prop:
                                        "fieldConfRows[" +
                                        scope.$index +
                                        "].label"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "field-label",
                                      attrs: { maxlength: "20", size: "mini" },
                                      model: {
                                        value: scope.row.label,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "label", $$v)
                                        },
                                        expression: "scope.row.label"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c("div", [_vm._v(_vm._s(scope.row.label))])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "输入类型",
                  width: "100",
                  align: "left",
                  "header-align": "left"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.userMode == 0
                          ? _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "fieldConfRows[" + scope.$index + "].type"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "field-type",
                                    attrs: { size: "mini" },
                                    on: {
                                      change: function($event) {
                                        _vm.syncFieldValueInfo(scope.$index)
                                      }
                                    },
                                    model: {
                                      value: scope.row.type,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "type", $$v)
                                      },
                                      expression: "scope.row.type"
                                    }
                                  },
                                  _vm._l(_vm.fieldTypes, function(fieldType) {
                                    return _c("el-option", {
                                      attrs: {
                                        value: fieldType.value,
                                        label: fieldType.label
                                      }
                                    })
                                  })
                                )
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(_vm.getFieldTypeLabel(scope.row.type))
                              )
                            ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "", width: "16", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "label",
                          {
                            staticStyle: { color: "#3f8edf" },
                            attrs: { title: "占用单元空间数量" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getFieldTypeCellSpaces(scope.row.type))
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: {
                      label: "数据类型",
                      width: "100",
                      align: "center",
                      "header-align": "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "fieldConfRows[" +
                                    scope.$index +
                                    "].valueType"
                                }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.valueType,
                                        expression: "scope.row.valueType"
                                      }
                                    ],
                                    staticClass: "field-valueType",
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            scope.row,
                                            "valueType",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        function($event) {
                                          _vm.syncFieldTypeInfo(scope.$index)
                                        }
                                      ]
                                    }
                                  },
                                  _vm._l(scope.row.validValueTypes, function(
                                    valueType
                                  ) {
                                    return _c(
                                      "option",
                                      { domProps: { value: valueType } },
                                      [_vm._v(_vm._s(valueType))]
                                    )
                                  })
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "数据来源", width: "90", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              [
                                scope.row.type == "Select" ||
                                scope.row.type == "RadioGroup"
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            _vm.editFieldDataList(scope.$index)
                                          }
                                        }
                                      },
                                      [_vm._v("数据列表")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (scope.row.type == "Date" ||
                                  scope.row.type == "Date2") &&
                                scope.row.valueType != "Integer"
                                  ? _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: scope.row.time,
                                            expression: "scope.row.time"
                                          }
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(scope.row.time)
                                            ? _vm._i(scope.row.time, null) > -1
                                            : scope.row.time
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = scope.row.time,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    scope.row,
                                                    "time",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    scope.row,
                                                    "time",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(scope.row, "time", $$c)
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" 带有时间")
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "", width: "64", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.type == "Select" ||
                            scope.row.type == "Casc"
                              ? _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.multiple,
                                        expression: "scope.row.multiple"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(scope.row.multiple)
                                        ? _vm._i(scope.row.multiple, null) > -1
                                        : scope.row.multiple
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = scope.row.multiple,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                scope.row,
                                                "multiple",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                scope.row,
                                                "multiple",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(scope.row, "multiple", $$c)
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" 多选")
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "默认值", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "fieldConfRows[" + scope.$index + "].value"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    scope.row.type == "Select" ||
                                    scope.row.type == "RadioGroup"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: scope.row.value,
                                              expression: "scope.row.value"
                                            }
                                          ],
                                          staticStyle: {
                                            width: "80px",
                                            height: "28px",
                                            "padding-top": "4px",
                                            "font-size": "12px",
                                            color: "navy"
                                          },
                                          attrs: {
                                            type: "text",
                                            maxlength: "30"
                                          },
                                          domProps: { value: scope.row.value },
                                          on: {
                                            change: function($event) {
                                              _vm.syncFieldTypeInfo(
                                                scope.$index
                                              )
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                scope.row,
                                                "value",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "Checkbox"
                                      ? _c("el-switch", {
                                          model: {
                                            value: scope.row.value,
                                            callback: function($$v) {
                                              _vm.$set(scope.row, "value", $$v)
                                            },
                                            expression: "scope.row.value"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "", width: "22", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.needFieldExtEditor(
                              scope.row.type,
                              scope.row.valueType
                            )
                              ? _c(
                                  "el-link",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.showFieldExtEditor(
                                          $event,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-more",
                                      attrs: { title: "设置特定扩展信息" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "基本项", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.basic,
                              expression: "scope.row.basic"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: scope.row.hidden
                          },
                          domProps: {
                            checked: Array.isArray(scope.row.basic)
                              ? _vm._i(scope.row.basic, null) > -1
                              : scope.row.basic
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = scope.row.basic,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        scope.row,
                                        "basic",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        scope.row,
                                        "basic",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(scope.row, "basic", $$c)
                                }
                              },
                              function($event) {
                                _vm.syncBasicField(scope.row, scope.$index)
                              }
                            ]
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "隐藏之", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.hidden,
                              expression: "scope.row.hidden"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.userMode > 0 && scope.row.ctxBindName
                          },
                          domProps: {
                            checked: Array.isArray(scope.row.hidden)
                              ? _vm._i(scope.row.hidden, null) > -1
                              : scope.row.hidden
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = scope.row.hidden,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        scope.row,
                                        "hidden",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        scope.row,
                                        "hidden",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(scope.row, "hidden", $$c)
                                }
                              },
                              function($event) {
                                _vm.syncHiddenField(scope.row, scope.$index)
                              }
                            ]
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userMode == 0 && this.forHisQry
                ? _c("el-table-column", {
                    attrs: {
                      label: "上下文属性",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.hidden
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-bottom": "0" },
                                        attrs: {
                                          prop:
                                            "fieldConfRows[" +
                                            scope.$index +
                                            "].ctxBindName"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "field-type",
                                            attrs: { size: "mini" },
                                            on: {
                                              change: function($event) {
                                                _vm.syncFieldValueInfo(
                                                  scope.$index
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row.ctxBindName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "ctxBindName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.ctxBindName"
                                            }
                                          },
                                          _vm._l(_vm.ctxFields, function(
                                            ctxField
                                          ) {
                                            return _c("el-option", {
                                              attrs: {
                                                value: ctxField.name,
                                                label: ctxField.value
                                              }
                                            })
                                          })
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "报表用", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: scope.row.rptUsed,
                                  expression: "scope.row.rptUsed"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(scope.row.rptUsed)
                                  ? _vm._i(scope.row.rptUsed, null) > -1
                                  : scope.row.rptUsed
                              },
                              on: {
                                change: function($event) {
                                  var $$a = scope.row.rptUsed,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          scope.row,
                                          "rptUsed",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          scope.row,
                                          "rptUsed",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(scope.row, "rptUsed", $$c)
                                  }
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "动态标签", width: "70", align: "left" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.mayBeDynaTagField(
                                      scope.row.type,
                                      scope.row.valueType
                                    ),
                                    expression:
                                      "mayBeDynaTagField(scope.row.type, scope.row.valueType)"
                                  }
                                ]
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: scope.row.dynaTag,
                                      expression: "scope.row.dynaTag"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(scope.row.dynaTag)
                                      ? _vm._i(scope.row.dynaTag, null) > -1
                                      : scope.row.dynaTag
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = scope.row.dynaTag,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                scope.row,
                                                "dynaTag",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                scope.row,
                                                "dynaTag",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(scope.row, "dynaTag", $$c)
                                        }
                                      },
                                      function($event) {
                                        _vm.syncFieldValueInfo(scope.$index)
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-link",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: scope.row.dynaTag,
                                        expression: "scope.row.dynaTag"
                                      }
                                    ],
                                    staticStyle: {
                                      cursor: "pointer",
                                      "margin-left": "8px"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showDynaTagEditor(
                                          $event,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-setting",
                                      attrs: {
                                        title: "设置动态标签字段配置信息"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.viewMode
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作/顺序",
                      width: "116",
                      align: "center",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-arrow-top pr10",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.moveQueryField(scope.$index, "prev")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-arrow-bottom pr10",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.moveQueryField(scope.$index, "next")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.userMode == 0
                                ? _c("i", {
                                    staticClass:
                                      "icon iconfont el-icon-delete pl10 pr10",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "orange"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.delQueryField(scope.$index)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd60b9a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd60b9a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/QueryFieldConf.vue
// module id = 2174
// module chunks = 0